module.exports = __webpack_public_path__ + "img/studio__home__mobile.aa286d90.svg";